import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';
import { IMobileBuild } from './get-mobile-build-query';
import { useSearchParams } from 'react-router-dom';

export const useGetBuildRequestByStatusOrBuildIdQuery = () => {
    const [searchParams] = useSearchParams();
    const buildRequestId = searchParams.get('buildId');
    const { getData } = useServiceClient();
    const appDetails = React.useCallback(() => getData(`${MyAppsEndPoints.GET_BUILD_REQUEST}?BuildId=${buildRequestId}&status=All`).then((res) => res.json()).catch((err) => err), [buildRequestId, getData]);
    return useQuery<IMobileBuild[]>(MyAppsQueryKey.GET_BUILD_REQUEST, appDetails, {
        refetchOnWindowFocus: false,
        enabled: false
    });
};
